import locales from '../locales/locales';
export default {
    'auto':{
        'name':locales.translatorSelectAutomatically,
        'minLevel':0,
        'cpp':1,
    },
    'deepseekv4_flash':{
        'name':'DeepSeek-V4 Flash',
        'minLevel':1,
        'cpp':1,
    },
    'gpt54_nano':{
        'name':'GPT-5.4 nano',
        'minLevel':1,
        'cpp':3,
    },
    'claude5_sonnet':{
        'name':'Claude Sonnet 5',
        'minLevel':2,
        'cpp':10,
    },
    'gpt56_terra':{
        'name':'GPT-5.6 Terra',
        'minLevel':3,
        'cpp':20,
    },
};

